import { defineComponent as r, computed as l, openBlock as c, createElementBlock as s, createElementVNode as t, toDisplayString as d, createCommentVNode as n, normalizeStyle as v, createStaticVNode as f } from "vue";
const p = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "5efdb210-0dae-4680-a544-b15dbdeddb9a" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#5efdb210-0dae-4680-a544-b15dbdeddb9a)" }, u = { key: 0 }, k = /* @__PURE__ */ f('<path fill="#0052b4" d="M256 0h256v512H0V256Z"></path><path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"></path><path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"></path><circle cx="382" cy="256" r="74" fill="#eee"></circle><path fill="#d80027" d="M363 221a14 14 0 0 0-14 14v10h-5v-6c0-6-5-11-11-11a3 3 0 0 0-3 3v25c0 1 1 3 3 3h16a13 13 0 0 0 13 12v6h-5c-7 0-12 5-12 11l3 3h25c2 0 3-2 3-3v-17h34v5h-5c-6 0-11 5-11 11 0 2 1 3 3 3h24c2 0 3-1 3-3v-33c5 0 10-4 10-9 0-6-5-10-10-10h-32a3 3 0 0 1-3-3c0-2 1-3 3-3h32v-7h-32a10 10 0 0 0 0 19h32c2 0 3 2 3 4 0 1-1 3-3 3h-35c-7 0-13-6-13-13a14 14 0 0 0-13-14z"></path>', 5), g = { fill: "none" }, b = ["r"], y = /* @__PURE__ */ r({
  __name: "au-tas",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(h) {
    const e = h, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), i = l(() => 256 + e.strokeWidth / 2);
    return (x, V) => (c(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      _,
      t("g", m, [
        e.flagName ? (c(), s("title", u, d(e.flagName), 1)) : n("", !0),
        k
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: i.value,
          fill: "none",
          style: v({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, p));
  }
});
export {
  y as default
};
//# sourceMappingURL=au-tas-4779e940.js.map
